import React from "react";
import "../App.css";
import devTestIcon from "./Assets/D&T.png";
import maintenanceIcon from "./Assets/Maintenance.png";
import itIcon from "./Assets/IT&ITES.png";
import securityIcon from "./Assets/Security.png";
import consultingIcon from "./Assets/Consulting.png";
import staffingIcon from "./Assets/Staffing.png";

const services = [
  {
    title: "DEVELOPMENT & TESTING",
    description:
      "Streamline your projects with our expert development and testing services. We build robust, scalable solutions and ensure their quality with thorough testing, so you can launch with confidence.",
    icon: devTestIcon,
  },
  {
    title: "MAINTENANCE",
    description:
      "Ensure your software remains up-to-date and efficient with our comprehensive maintenance services. Trust us to handle the technical details, so you can focus on what you do best.",
    icon: maintenanceIcon,
  },
  {
    title: "IT & ITES SOLUTIONS",
    description:
      "Boost your business with our IT & ITES solutions. We offer tailored IT management and innovative services to enhance efficiency and drive growth. Let us handle your tech needs so you can focus on success.",
    icon: itIcon,
  },
  {
    title: "SECURITY",
    description:
      "We're shaping the future of cybersecurity with next-gen solutions that stay ahead of emerging threats. Our advanced technology and proactive strategies ensure your digital assets are secure now and for years to come.",
    icon: securityIcon,
  },
  {
    title: "CONSULTING",
    description:
      "Unlock your business potential with our expert consulting services. We provide strategic insights and practical solutions to help you navigate challenges and achieve your goals.",
    icon: consultingIcon,
  },
  {
    title: "STAFFING SERVICES",
    description:
      "A large network of job candidates, so it is easy to find people to fill the jobs. We have the expertise and knowledge to identify the perfect applicants for the jobs each company needs to fill.",
    icon: staffingIcon,
  },
];


const OurServices = () => {
  return (
    <section className="our-services">
      <h2>Our Services</h2>
      <p className="intro">
        We offer a variety of services and end-to-end solutions for companies
        seeking support on IT and ITES projects. We deliver all kinds of
        solutions to help businesses strategize, execute, and deliver projects
        exactly how their customers want them.
      </p>

      <div className="service-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="icon">
              <img src={service.icon} alt={`${service.title} icon`} />
            </div>
            <h3>{service.title}</h3>{" "}
            <p>{service.description}</p>
          </div>
        ))}
      </div>
      <h2>Kaizen</h2>
      <p className="intro">
        Kaizen is a Japanese word that translates to "continuous improvement" or
        "change for the better." The Kaizen Strategy, rooted in Japanese
        business philosophy, focuses on gradual growth in productivity through
        employee engagement and continuous improvement in operations.
      </p>
    </section>
  );
};

export default OurServices;
